import React from "react";
import CreateTestRunModal from "../Modal/CreateTestRunModal";
import CloneTestRunModel from "../Modal/CloneTestRunModel";
import EditTestRunModal from "../Modal/EditTestRunModal";
import ConfirmationModal from "../Modal/ConfirmationModal";

const DO_NOTHING = ()=>{};
export default function TestRunPopups({popupData={}}){
    const { title='', show=false, closePopup=DO_NOTHING, errorFunction=DO_NOTHING, successFunction=DO_NOTHING, confirmationFunction=DO_NOTHING, data={}, message='' } = popupData;

    const renderPopups = () => {
        switch (popupData.type) {
            case 'create':
                return (
                    <CreateTestRunModal
                        isOpen={show}
                        onClose={closePopup}
                        onCreate={()=>{
                            successFunction({ type: 'create', actionType: "success", message: `Testrun created successfully` })
                        }}
                        onError={(errorType, errorMessage)=>errorFunction({type: 'create', errorType, errorMessage})}
                    />
                )
                break;
            case 'clone':    
                return (
                    <CloneTestRunModel
                        isOpen={show}
                        title={title}
                        onClose={closePopup}
                        onClone={()=>{
                            successFunction({ type: 'clone', actionType: "success", message: `${data?.testCycleName || 'Testrun'} cloned successfully` })
                        }}
                        data={data}
                        onError={(errorType, errorMessage)=>errorFunction({type: 'clone', errorType, errorMessage})}
                    />
                )
                break;
            case 'edit':
                return (
                    <EditTestRunModal
                        isOpen={show}
                        onClose={closePopup}
                        onUpdate={()=>{
                            successFunction({ type: 'edit', actionType: "success", message: `${data?.testCycleName || 'Testrun'} updated successfully` })
                        }}
                        onError={(errorType, errorMessage)=>errorFunction({type: 'edit', errorType, errorMessage})}
                        testRunData={data}
                    />
                )
            case "delete":
            case "multidelete":    
                return (
                    <ConfirmationModal
                        open={show}
                        onClose={closePopup}
                        onConfirm={()=>{
                            confirmationFunction({ type: popupData.type, idsAarray:data.ids, names: data.names  }  )
                        }}   
                        title={title}
                        message={message}
                    />
                )       
            default:
                return null;
        }
    }
    return (
        <>
           {renderPopups()}
        </>
    )
}

